import { useCurrentPath } from '@service-initiation/shared-data-access-flow-manager';
import { HorizontalRule } from '@service-initiation/shared-ui-horizontal-rule';
import { Route } from '@service-initiation/tech-care-data-access-routing';
import {
  DeliveryMethod,
  useDeliveryMethodValue,
} from '@service-initiation/tech-care-data-access-store';

import { AboutOurRepairsSection } from './AboutOurRepairsSection';
import { PricingDetailsSection } from './PricingDetailsSection';
import { NeedToRescheduleSection } from './RescheduleSection';
import { SummarySection } from './SummarySection';
import { VisitDetailsSection } from './VisitDetailsSection';

export const AppointmentOverview = () => {
  const deliveryMethod = useDeliveryMethodValue();
  const currentPath = useCurrentPath();

  return (
    <>
      <SummarySection />
      {[Route.Confirmation, Route.CustomerDetails].includes(
        currentPath as Route
      ) &&
        deliveryMethod !== DeliveryMethod.ComeToMe && (
          <>
            <HorizontalRule />
            <PricingDetailsSection />
          </>
        )}
      <HorizontalRule />
      <VisitDetailsSection />
      {currentPath !== Route.Confirmation && (
        <>
          <HorizontalRule />
          <AboutOurRepairsSection />
        </>
      )}
      {currentPath === Route.Confirmation &&
        deliveryMethod === DeliveryMethod.VisitStore && (
          <>
            <HorizontalRule />
            <NeedToRescheduleSection />
          </>
        )}
    </>
  );
};
